import { AuthService } from '@services/auth.service';
import { OrdersService } from '@services/orders.service';
import { ProductTypesService } from './../shared/services/productTypes.service';
import { UsersService } from './../shared/services/users.service';
import { SitesService } from './../shared/services/sites.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, FormControl } from '@angular/forms';
import { FormEditBaseComponent } from '@components/form-edit-base.component';
import { UiService } from '@services/ui.service';
import { Site } from '@classes/site';
import { User } from '@classes/user/user';
import { RoleName } from '@enums/role-name.enum';
import { ProductType } from '@classes/productType';
import { Order } from '@classes/order/order';
import { OrderStatus } from '@enums/order-status.enum';
import { OrderType } from '@enums/order-type.enum';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-advanced-search',
  templateUrl: './advanced-search.component.html',
  styleUrls: ['./advanced-search.component.scss']
})
export class AdvancedSearchComponent extends FormEditBaseComponent implements OnInit {

  results = false;
  sites: Site[] = [];
  drivers: User[] = [];
  productTypes: ProductType[] = [];

  orders: Order[] = [];

  isDispatcher: boolean;
  isLoadingResults: boolean;

  displayedColumns: any[] = [
    'identifier',
    'startDate',
    // 'urgency',
    'sender',
    'receivers',
    'status',
    'client',
    'site',
    // 'createdBy',
    // 'createdOn',
    'driver',
    'actions'];


  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<Order>;

  constructor(
    protected uiSrv: UiService,
    protected fb: UntypedFormBuilder,
    private sitesSrv: SitesService,
    private usersSrv: UsersService,
    private productTypesSrv: ProductTypesService,
    private ordersSrv: OrdersService,
    private authSrv: AuthService,
    private router: Router,
  ) {
    super(uiSrv, fb);
  }

  ngOnInit(): void {
    this.isDispatcher =
      this.authSrv.getUser().role.name === RoleName.bizzdev ||
      this.authSrv.getUser().role.name === RoleName.super_admin ||
      this.authSrv.getUser().role.name === RoleName.admin ||
      this.authSrv.getUser().role.name === RoleName.admin_subcontractor ||
      this.authSrv.getUser().role.name === RoleName.dispatcher;

    this.initSub();
  }

  initSub(): void {
    const sitesPromise = new Promise((resolve, reject) => {
      this.sitesSrv.getList()
        .subscribe(sitesFromSrv => {
          this.sites = sitesFromSrv;
          resolve(true);
        });
    });

    const driversPromise = new Promise((resolve, reject) => {
      this.usersSrv.getList()
        .subscribe(driversFromSrv => {
          this.drivers = [...driversFromSrv].filter(oneDriver => oneDriver.role.name !== RoleName.admin_client && oneDriver.role.name !== RoleName.client);
          resolve(true);
        });
    });

    const productTypesPromise = new Promise((resolve, reject) => {
      this.productTypesSrv.getList()
        .subscribe(productTypesFromSrv => {
          this.productTypes = productTypesFromSrv;
          resolve(true);
        });
    });

    Promise.all([sitesPromise, driversPromise, productTypesPromise])
      .then(() => {
        this.isLoading = false;
        this.initForm();
      });

    this.addSubscription(
      this.ordersSrv.ordersListChanged
        .subscribe(orders => {
          this.orders = orders;
          this.initTable();
        })
    );
  }

  initForm() {
    this.editForm = this.fb.group({
      site: [null],
      scanCode: [null],
      startDate: [null],
      productType: [null],
      tag: [null],
      driver: [null],
      globalFilter: [null]
    });
  }

  initTable() {
    this.dataSource = new MatTableDataSource(this.orders);
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'sender': return item.sender?.address?.name;
        case 'site': return item.site.name;
        case 'client': return item.client.name;
        default: return item[property];
      }
    };
    this.dataSource.paginator = this.paginator;
    this.isLoadingResults = false;
  }

  search(): void {
    this.isLoadingResults = true;
    this.results = true;
    this.ordersSrv.getSearchOverall(this.editForm.value);
  }

  isControlSet(control: string): boolean {
    return !!this.editForm.get(control);
  }

  showStatusText(status: OrderStatus): string {
    return 'orders.status.' + OrderStatus[status];
  }

  showTypeText(type: OrderType): string {
    return 'orders.type.' + OrderType[type];
  }

  onSelectOrder(id: string): void {
    this.router.navigate([`orders/${id}`]);
  }

  clearFilters(): void {
    this.editForm.reset();
    this.results = false;
  }

}
